import React from 'react'
import Header from '../../Component/Header'
import Treasurers from '../Treasurers'
import Footer from '../../Component/Footer'

function LayoutTreasurers() {
    return (
        <>
            <Header />
            <Treasurers />
            <Footer />
        </>
    )
}

export default LayoutTreasurers
